/* ======= All App File Include Here ======= */
// Vuetify Css
import 'vuetify/dist/vuetify.css'

// Editor Css
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import 'vue-tour/dist/vue-tour.css'

// Drag And Drop Css
import 'vue2-dragula/styles/dragula.css'

// nprogress
import 'nprogress/nprogress.css'

// Icon Files
import 'weather-icons/css/weather-icons.min.css'
import '../assets/themify-icons/themify-icons.css'

// leaflet map css
import 'leaflet/dist/leaflet.css'

// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// animate css
import '../assets/animate.css';

// Global Scss File
import '../assets/scss/_style.scss'

// Video Player CSS
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

// Image Croppa CSS
import 'vue-croppa/dist/vue-croppa.css';